import React from "react";
import { Col, Row } from "react-bootstrap";
import { BillableItems, Credits, Invoices, PaymentMethod } from "./components";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { EnvironmentHelper } from "../helpers";
interface Props {

}


export const BillingPage: React.FC<Props> = props => {
  const billingHeaderRef = React.useRef<HTMLHeadingElement>(null);
  const [stripePromise, setStripePromise] = React.useState<Promise<Stripe>>(null);
  const init = () => {
    setStripePromise(loadStripe(EnvironmentHelper.StripeKey));
  }

  React.useEffect(init, []);  
  
  return (
    <div className="page-container">
      <div className="page-header">
        <h1 ref={billingHeaderRef}><i className="fas fa-credit-card"></i> Billing</h1>
      </div>
      <Row>
        <Col xs={12} lg={6}>
          <Credits />
          <Invoices headerRef={billingHeaderRef} />
        </Col>
        <Col xs={12} lg={6}>
          <Elements stripe={stripePromise} >
            <PaymentMethod />
          </Elements>
          <BillableItems />
        </Col>
      </Row>
    </div>
  );
};